// extracted by mini-css-extract-plugin
var _1 = "MessageAppStyle-module__logout___m0nIm";
var _2 = "MessageAppStyle-module__message-container___kRLQj";
var _3 = "MessageAppStyle-module__message-footer-container___nsel7";
var _4 = "MessageAppStyle-module__message-loader____isbu";
var _5 = "MessageAppStyle-module__message-page___QRVRG";
var _6 = "MessageAppStyle-module__message-container___kRLQj";
var _7 = "MessageAppStyle-module__message-footer-container___nsel7";
var _8 = "MessageAppStyle-module__message-loader____isbu";
var _9 = "MessageAppStyle-module__message-page___QRVRG";
export { _1 as "logout", _2 as "message-container", _3 as "message-footer-container", _4 as "message-loader", _5 as "message-page", _6 as "messageContainer", _7 as "messageFooterContainer", _8 as "messageLoader", _9 as "messagePage" }
